var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PacemPolylineElement_1;
import { CustomElement, Watch, PropertyConverters, P, Utils } from '@pacem/pacem-core';
import { parseAsNumericalArray } from '@pacem/pacem-foundation';
import { ShapeElement } from './types';
import { TAG_MIDDLE_NAME } from './constants';
import { Shape } from './drawing';
//namespace Pacem.Components.Drawing {
const PointArrayOrJsonConverter = {
    convert: (attr) => {
        const arr = parseAsNumericalArray(attr);
        if (arr.length % 2 === 0) {
            const retval = [];
            for (let j = 0; j < arr.length; j += 2) {
                retval.push({ x: arr[j], y: arr[j + 1] });
            }
            return retval;
        }
        return JSON.parse(attr);
    },
    convertBack: (prop) => JSON.stringify(prop)
};
let PacemPolylineElement = PacemPolylineElement_1 = class PacemPolylineElement extends ShapeElement {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'points':
                case 'closed':
                    this.recomputeShape();
                    break;
            }
        }
    }
    static getShapeGeometry(points, closed) {
        if (Utils.isNullOrEmpty(points)) {
            return Shape.empty();
        }
        let d = '';
        let xmin = Number.MAX_VALUE, ymin = Number.MAX_VALUE, xmax = Number.MIN_VALUE, ymax = Number.MIN_VALUE;
        for (let j = 0; j < points.length; j++) {
            const { x, y } = points[j];
            d += `${(j === 0 ? 'M' : 'L')} ${x} ${y} `;
            xmin = Math.min(xmin, x);
            xmax = Math.max(xmax, x);
            ymin = Math.min(ymin, y);
            ymax = Math.max(ymax, y);
        }
        const boundingRect = { x: xmin, y: ymin, width: xmax - xmin, height: ymax - ymin };
        if (closed) {
            d += 'Z';
        }
        return { pathData: d, vertices: points, boundingRect };
    }
    getShapeGeometry() {
        return PacemPolylineElement_1.getShapeGeometry(this.points, this.closed);
    }
    getPathData() {
        const { pathData } = this.getShapeGeometry();
        return pathData;
    }
    static getPathData(points, closed) {
        const { pathData } = PacemPolylineElement_1.getShapeGeometry(points, closed);
        return pathData;
    }
};
__decorate([
    Watch({ emit: false, converter: PointArrayOrJsonConverter })
], PacemPolylineElement.prototype, "points", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemPolylineElement.prototype, "closed", void 0);
PacemPolylineElement = PacemPolylineElement_1 = __decorate([
    CustomElement({ tagName: P + '-' + TAG_MIDDLE_NAME + '-polyline' })
], PacemPolylineElement);
export { PacemPolylineElement };
